import React from "react"
import Slider from "react-slick"
import styled from "styled-components"
import Icon from "./icon"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const Img = styled.img`
    height: 250px;
    object-fit: contain;
    @media screen and (min-width: 768px) {
        object-fit: cover;
    }
`
const Dot = styled.ul`
    li {
        margin: 0;

        &.slick-active button:before {
            color: ${props => props.theme.primary};
            opacity: 1;
        }
    }
`

const Container = styled.div`
    padding: 1rem 0rem;
    margin-bottom: 0.5rem;
    box-sizing: border-box;
    transform: scale(0.94);
    @media screen and (min-width: 768px) {
        padding: 1rem 2rem;
    }
`

const IconContainer = styled.div`
    i {
        transition: none;
    }
    &:hover i {
        color: ${props => props.theme.text};
    }
`

function NextArrow({ className, style, onClick }) {
    return (
        <IconContainer
            className={className}
            style={{ ...style }}
            onClick={onClick}
        >
            <Icon
                style={{
                    transform: "translateX(-22px) translateY(9px)",
                    position: "absolute",
                    background: "transparent",
                }}
                size={36}
            >
                chevron_right
            </Icon>
        </IconContainer>
    )
}

function PrevArrow({ className, style, onClick }) {
    return (
        <IconContainer
            className={className}
            style={{ ...style }}
            onClick={onClick}
        >
            <Icon
                style={{
                    transform: "translateX(-36px) translateY(9px)",
                    position: "absolute",
                    background: "transparent",
                }}
                size={36}
            >
                chevron_left
            </Icon>
        </IconContainer>
    )
}

export default function Carousel({ images, data }) {
    // const slider = useRef()
    let slider1 = []
    const handleClick = e => {
        e.preventDefault()
        slider1.slickNext()
    }
    const settings = {
        dots: true,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: "progressive",
        appendDots: dots => <Dot>{dots}</Dot>,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        slickNext: {},
    }
    return (
        <Container>
            <Slider ref={slider => (slider1 = slider)} {...settings}>
                {data.map((el, key) => {
                    return (
                        <Img
                            srcSet={images[el]}
                            key={key}
                            alt=""
                            onClick={handleClick}
                        />
                    )
                })}
            </Slider>
        </Container>
    )
}
